// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandedBox_root___Uwg9"};